<template>
  <div id="contenedor-ejecucion-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Supervisión">
            <template v-slot:opciones-derecha>
              <v-menu
                v-model="mostrarMenuExportar"
                :close-on-content-click="false"
                offset-y>
                  <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                      v-on="{ ...onMenu, ...onTooltip }">
                    <v-icon> mdi-file-excel </v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item
                  @click="mostrarExportarConceptosEstimados = !mostrarExportarConceptosEstimados"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Conceptos Estimados </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  @click="mostrarExportarConceptosContratos = !mostrarExportarConceptosContratos"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Conceptos de Contratos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirCalendarioActividades">
                    <v-icon> mdi-calendar-month </v-icon>
                  </v-btn>
                </template>
                <span> Ver Calendario de Pendientes </span>
              </v-tooltip>
              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :to="{ name: 'contratoEjecucionEstadisticas' }">
                  <v-icon>mdi-poll</v-icon>
                </v-btn>
              </template>
              <span>Estadisticas</span>
            </v-tooltip>
            <v-tooltip
            v-if="mixValidaScopesActions(1)"
            top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :to="{ name: 'ejecuccionConfiguracionFirmas' }">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
              </template>
              <span>Configuracion</span>
            </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            :listaContratos="getContratos">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratos="getListadoDeContratos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarExportarConceptosEstimados"
      v-model="mostrarExportarConceptosEstimados"
      width="400">
      <excel-conceptos-estimados
      v-on:cerrar="mostrarExportarConceptosEstimados = !mostrarExportarConceptosEstimados">
      </excel-conceptos-estimados>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarConceptosContratos"
      v-model="mostrarExportarConceptosContratos"
      width="400">
      <excel-conceptos-contratos
      v-on:cerrar="mostrarExportarConceptosContratos = !mostrarExportarConceptosContratos">
      </excel-conceptos-contratos>
    </v-dialog>
    <!-- Ventana Calendario de Pendientes de Contratos -->
    <v-dialog
      scrollable
      v-model="mostrarVentanaCalendarioActividades"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Calendario de Pendientes de Contratos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarCalendarioActividades">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- calendario de pendientes -->
          <calendario-actividades
          :listadoContratos="getContratos"
          :actividadesTodas="getActividadesTodas">
          </calendario-actividades>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarCalendarioActividades"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosSupervision.gql';
import ACTIVIDADES_TODAS from '@/graphql/querys/administracion/actividades/actividadesTodas.gql';
import CalendarioActividades from '@/components/administracion/contratos/calendarioactividades/CalendarioActividades.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import ExcelConceptosEstimados from '@/components/exportar/exceles/ExcelConceptosEstimados.vue';
import ExcelConceptosContratos from '@/components/exportar/exceles/ExcelConceptosContratos.vue';
import CustomButton from '@/components/buttons/Button.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'EjecucionDefault',
  components: {
    TituloToolBar,
    ExcelConceptosEstimados,
    ExcelConceptosContratos,
    CalendarioActividades,
    CustomButton,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarMenuExportar: false,
      mostrarVentanaCalendarioActividades: false,
      mostrarExportarConceptosEstimados: false,
      mostrarExportarConceptosContratos: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  methods: {
    abrirCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = true;
    },
    cerrarCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = false;
    },
  },
  mounted() {
    // Checar si hay filtros guardados.
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('filtros-ejecucion'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('filtros-ejecucion'));
    }
  },
  apollo: {
    contratos: {
      query: CONTRATOS,
      fetchPolicy: 'network-only',
    },
    actividadesTodas: {
      query: ACTIVIDADES_TODAS,
    },
  },
  computed: {
    getActividadesTodas() {
      if (!this.actividadesTodas) return [];
      return this.actividadesTodas;
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos// Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getListadoDeContratos() {
      if (!this.contratos) return [];
      return this.contratos
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        // .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .sort((a, b) => a.orden - b.orden)
        // Filtrar por ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => ({
          ...contrato,
          cantidadEstimaciones: contrato.estimaciones.length,
        }))
        .map((contrato) => {
          const { avancesFisicos } = contrato;
          if (avancesFisicos.length <= 0) {
            return {
              ...contrato,
            };
          }

          const ultimosConceptosReportados = [];

          const conceptosIds = [...new Set(avancesFisicos.map(({ idConcepto }) => idConcepto))];

          conceptosIds.forEach((id) => {
            const conceptos = avancesFisicos
              .filter(({ idConcepto }) => idConcepto === id)
              .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));

            ultimosConceptosReportados.push(conceptos[0]);
          });

          return {
            ...contrato,
            ultimosConceptosReportados,
          };
        })
        .map((contrato) => {
          const {
            estimaciones, ultimosConceptosReportados, importe, modificado,
          } = contrato;

          const importeEstimado = this.$ObjSumar(estimaciones, 'importeEstimado');
          const importeAvanceFisico = this.$ObjSumar(ultimosConceptosReportados, 'importe');

          const totalDeAvance = (importeEstimado + importeAvanceFisico);

          const totalContratado = (importe + modificado.importe);

          const avance = this.$numberRound(((totalDeAvance / totalContratado) * 100));

          return {
            ...contrato,
            porcentajeAvanceFisico: avance || 0,
          };
        })
        .map((contrato) => ({
          ...contrato,
          reportesFisicos: contrato.reportesFisicos.map((reporte) => ({
            ...reporte,
            avanceDiferencia: (reporte.avanceFisico - reporte.avanceProgramado),
          })),
        }))
        .map((contrato) => ({
          ...contrato,
          ultimoReporte: contrato.reportesFisicos.find(({ esUltimo }) => esUltimo === true) || null,
        }));
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('filtros-ejecucion', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('filtros-ejecucion');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>
